@for (stock of stocks; track stock) {
  <div>
    @if (stock.area) {
      <p-tag
        severity="warn"
        value="{{ stock.area }}"></p-tag>
    }
    <p-tag
      severity="success"
      value="{{ stock.prefecture }}"></p-tag>
    <p-tag
      severity="primary"
      value="{{ getStoreName(stock.storeName) }}"></p-tag>
    <p-tag
      [style]="getStyle(stock.hasStock)"
      severity="danger"
      value="{{ getStockDisplay(stock) }}"></p-tag>
  </div>
}
